(() => {
  if (window.MuranoCaptacaoV4) return;
  const instances = new Map();
  function initialize(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const gallery = root.querySelector('.lifestyle-gallery');
    const mobileLayout = window.matchMedia('(max-width: 760px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let previousMobile = null;
    let observer;
    for (const button of root.querySelectorAll('.video-sound')) {
      const video = button.parentElement.querySelector('.lifestyle-video');
      if (!video || !(video.currentSrc || video.getAttribute('src') || video.querySelector('source[src]'))) {
        button.hidden = true;
        continue;
      }
      button.addEventListener('click', () => {
        video.muted = !video.muted;
        video.volume = 1;
        video.play().catch(() => {});
        const audible = !video.muted;
        button.setAttribute('aria-pressed', String(audible));
        button.textContent = audible ? root.dataset.soundOff : root.dataset.soundOn;
        button.setAttribute('aria-label', audible ? root.dataset.soundOffLabel : root.dataset.soundOnLabel);
      }, { signal });
    }
    if (gallery && !reducedMotion.matches && 'IntersectionObserver' in window) {
      gallery.classList.add('is-animated');
      observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return;
        gallery.classList.add('is-visible');
        observer.disconnect();
      }, { threshold: .2 });
      observer.observe(gallery);
    }
    function centerGallery() {
      if (!gallery || mobileLayout.matches === previousMobile) return;
      previousMobile = mobileLayout.matches;
      if (mobileLayout.matches && gallery.children[1]) {
        const card = gallery.children[1];
        gallery.scrollLeft = card.offsetLeft - gallery.offsetLeft - (gallery.clientWidth - card.clientWidth) / 2;
      } else {
        gallery.scrollLeft = 0;
      }
    }
    centerGallery();
    window.addEventListener('load', centerGallery, { once: true, signal });
    mobileLayout.addEventListener('change', centerGallery, { signal });
    for (const rail of root.querySelectorAll('.lifestyle-gallery, .reviews')) {
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
        event.preventDefault();
        const step = rail.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap || 0);
        rail.scrollBy({ left: event.key === 'ArrowRight' ? step : -step, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      }, { signal });
    }
    for (const item of root.querySelectorAll('.faq-list details')) {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        for (const sibling of root.querySelectorAll('.faq-list details[open]')) {
          if (sibling !== item) sibling.open = false;
        }
      }, { signal });
    }
    instances.set(root, () => {
      controller.abort();
      if (observer) observer.disconnect();
      root.querySelectorAll('video').forEach(video => video.pause());
      instances.delete(root);
    });
  }
  function mount(container) {
    if (container.matches && container.matches('[data-murano-captacao-v4]')) initialize(container);
    container.querySelectorAll('[data-murano-captacao-v4]').forEach(initialize);
  }
  window.MuranoCaptacaoV4 = { mount };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  } else {
    mount(document);
  }
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) {
      if (event.target === root || event.target.contains(root)) cleanup();
    }
  });
})();
